import React, { useState } from "react";
import { Button, Grid, Skeleton, Typography } from "@mui/material";
import clock from "assets/images/greyClock.svg";
import CommonForm from "./CommonForm";

function ChooseCab(props) {
  const [selectedItem, setSelectedItem] = useState(0);
  const [type, setType] = useState(props?.rateCalculationData ? props?.rateCalculationData?.[0]?.carType : 'Car');
  const [rateData, setRateData] = useState(props?.rateCalculationData?.[0]);
  const onClickCab = () => {
    props?.onClickCab(rateData)
  };
  const handleItemClick = (index, carType, data) => {
    setSelectedItem(index);
    setType(carType);
    setRateData(data);
  };
  const duration = (data) => {
    if (data?.eta || data?.time) {
      let totalMinutes = data.eta ? data.eta * 60 : 0; // Convert fractional hours to total minutes
      let hours = Math.floor(totalMinutes / 60); // Extract hours
      let minutes = Math.round(totalMinutes % 60); // Extract remaining minutes (rounded)
      return (
        <div className="flex items-center gap-[5px]">
          <img src={clock} alt="clock" className="w-4 h-4" />
          <span>
            {data?.time && `${data.time} hr `}
            {data?.eta &&
              `${hours > 0 ? `${hours} hr ` : ""}${minutes > 0 ? `${minutes} min` : ""}`}
          </span>
        </div>

      );
    }
    return null; // Return null if no time-related data is present
  };

  return (
    <Grid container>
      <Grid
        item
        container
        md={12}
        direction="column"
        spacing={2}
        className="marginLeft10 myRideMain"
      >
        <Grid item direction="column">
          <Typography className=" fontMedium">Choose Vehicle</Typography>
        </Grid>
        <Grid item 
          spacing={2} 
          className={`${props?.rateCalculationData.length > 0 ? 
            'max-h-[40vh] overflow-y-auto' 
            : ''}`} 
           sx={{
              width: { xs: "90%", sm: "46%" },
              mx: { xs: "auto", sm: 0 }, 
            }}
        >

          {props?.rateCalculationData?.map((car, index) => (
            <Grid
              key={index}
              item
              container
              alignItems="center"
              className={`cardDesign cursor ${selectedItem === index
                ? "border-[3px] border-[#0f538d] rounded-[8px]"
                : "border border-transparent"
                }`}
              onClick={() => handleItemClick(index, car?.carType, car)}
              sx={{
                borderRadius: "10px",
                padding: "10px 14px",
                mb: 1.5,
              }}
            >
              {/* --- Car Image --- */}
              <div className="flex-shrink-0">
                <img
                  src={car?.masterCarType?.avtar?.url || car?.carImg}
                  alt="car"
                  className="object-contain w-[95px] h-[50px]"
                />
              </div>

              {/* --- Small Gap --- */}
              <div className="w-[8px]" />

              {/* --- Car Details --- */}
              <div className="flex flex-col justify-center flex-[1.2]">
                <Typography className="fontSemi leading-tight">
                  {car?.carType}
                </Typography>
                <div className="flex items-center text-sm text-gray-500 font12 fw600 gap-[6px]">
                  <span>{parseFloat(car?.distance).toFixed(1)} km</span>
                  <div className="flex items-center gap-[4px]">
                    <span>{duration(car)}</span>
                  </div>
                </div>
              </div>

              {/* --- Price Section --- */}
              <div className="text-right font-bold font16 text-black min-w-[60px]">
                ₹ {Math.round(JSON.parse(car?.totalAmount))}
              </div>
            </Grid>
          ))}

        </Grid>
        {/* <Grid item className="alignTextCenter flex item-end" width={"30%"}>
          <Button
            variant="contained"
            size="medium"
            fullWidth
            className="pt-6 border-t border-dashed border-gray-300"
            onClick={onClickCab}
          >

            {`Choose ${type}`}
          </Button>
        </Grid> */}

        <div className="mb-4 border-t border-dashed border-gray-300">
          <div className="w-[46%] sm:w-[46%] w-[90%] mx-auto sm:mx-0 text-center">
            <CommonForm
              button={`Choose ${type}`}
              onSubmittBtn={onClickCab}
            />
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default ChooseCab;
